(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/arena-react/assets/helpers/product-helpers.js') >= 0) return;  svs.modules.push('/modules/arena-react/assets/helpers/product-helpers.js');

'use strict';

const {
  isToday,
  isTomorrow,
  format,
  differenceInDays
} = dateFns;
const formatRegClosetime = regCloseTimes => {
  const dates = regCloseTimes.map(d => {
    let ret = '';
    if (isToday(d)) {
      ret += 'idag';
    } else if (isTomorrow(d)) {
      ret += 'imorgon';
    } else if (Math.abs(differenceInDays(d, new Date())) > 6) {
      ret += format(d, 'd MMMM', {
        locale: dateFns.locales.sv
      });
    } else {
      ret += format(d, 'EEEE', {
        locale: dateFns.locales.sv
      });
    }
    ret += " ".concat(format(d, 'HH:mm', {
      locale: dateFns.locales.sv
    }));
    ret = ret.charAt(0).toUpperCase() + ret.slice(1);
    return ret.replace(/\s/g, '\xA0');
  });
  return dates.join(' och ');
};
svs.arena.helpers.productHelpers = {
  formatRegClosetime
};

 })(window);